/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 13/11/2013
 * Time: 13:17
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Message', function (){

        var  message = function (type,text)
        {
            this.type = type;
            this.text = text;

        }

        return  message;
    });
angular.module('FlexyBeautyApp.services').
    factory('MessageSrv',["$rootScope","$timeout","$log","Message","MessageData",
        function ($rootScope,$timeout,$log,Message,MessageData){
        var messageSrv= {};

        messageSrv.cleanMessage = function() {
            if (MessageData.messages.length>0)
            {
                MessageData.cleanMessage();
                $rootScope.$emit("fxbMessage",null);
            }
        };
        messageSrv.send =  function(type,text,isNotFromAngularEvent)
        {
            //Currently manage only one message (but many in future dev)
            var message = new Message(type,text)
            MessageData.add(message);
            //emit To directive fxbMessage ('messageUserAction', function()
            $rootScope.$emit("fxbMessage",message,isNotFromAngularEvent);

        }
        return messageSrv;
    }]);

angular.module('FlexyBeautyApp.services').
    factory('MessageData',["$rootScope","$timeout","$log","Message",
        function ($rootScope,$timeout,$log,Message){
        var messageData = {reset :null,messages : []};

        messageData.cleanMessage  = function()
        {
            messageData.messages = [];
        }

        messageData.add =  function(message)
        {
            this.messages.push(message);
        }
        messageData.clear =  function()
        {
            messageData.messages = [];
        }
        return messageData;
    }]);


// WEBPACK FOOTER //
// ./js/services/tools/message.js